module.exports = __webpack_public_path__ + "img/37_146.030df95d.png";